import React from "react";
import { Box, Container, Grid, Typography, Paper, Link } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { Map } from "@mui/icons-material";

// Data for the feature cards to avoid repetition
const features = [
    {
        title: "End-to-end capabilities",
        description: "From cavity walls to solar PV, we offer both hands-on delivery and back-office documentation support.",
    },
    {
        title: "Reduced overhead",
        description: "We own the compliance. You own the result. Reduce in-house admin and focus on scaling your delivery.",
    },
    {
        title: "Audit confidence",
        description: "Our supervisors and coordinators build ECO4 audit trails as work progresses—no chasing paperwork at the end.",
    },
    {
        title: "UK-wide reach with localised delivery",
        description: "Teams available across regions, ready for rapid deployment.",
    },
];

const WhyTrustUsSection = () => {
    return (
        <>
            <Box
                sx={{
                    py: 8,
                    backgroundColor: "#fff", // Dark teal background from image
                    color: "#003333",
                }}
            >
                <Container maxWidth="lg">
                    {/* Main Heading */}
                    <Typography
                        variant="h4"
                        component="h3"
                        sx={{
                            fontWeight: "bold",
                            mb: 6
                        }}
                    >
                        Why our partners trust us
                    </Typography>

                    {/* Feature Cards Grid */}
                    <Grid container spacing={4}>
                        {features.map((feature, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <Paper
                                    sx={{
                                        p: 3,
                                        height: "100%",
                                        borderRadius: "12px",
                                        color: "#003333", // Dark text color for content inside cards
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                    elevation={3}
                                >
                                    <Typography variant="h6" component="h3" sx={{ fontWeight: "bold", mb: 1 }}>
                                        {feature.title}
                                    </Typography>
                                    <Typography variant="body2">
                                        {feature.description}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>

                    {/* Bottom Contact Section */}

                </Container>
            </Box>
            <Box sx={{ background: '#003333' }}>
                <Container maxWidth="lg">
                    <Box
                        sx={{
                            mt: 8, // Margin top for spacing from the cards
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" }, // Stacks on mobile, row on desktop
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 3,
                            p: 2
                        }}
                    >
                        {/* Left side text */}
                        <Typography variant="body1" sx={{ maxWidth: { md: 400 }, textAlign: { xs: 'center', md: 'left' } }} color="#fff">
                            Ask us for a tailored collaboration plan to meet your project timelines and compliance targets.
                        </Typography>

                        {/* Right side contact info */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" }, // Stacks on small mobile, row on larger screens
                                alignItems: { xs: 'start', md: 'center' },
                                gap: 3,
                            }}
                        >
                            {/* Phone Number */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box
                                    sx={{
                                        backgroundColor: "#39b54a", // Green circle from image
                                        borderRadius: "50%",
                                        p: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <PhoneIcon sx={{ color: "white" }} />
                                </Box>
                                <Link variant="body1" sx={{ fontWeight: "medium" }} color="#fff" href="tel:07568540041">
                                    07568540041
                                </Link>
                            </Box>

                            {/* Email Address */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box
                                    sx={{
                                        backgroundColor: "#39b54a", // Green circle
                                        borderRadius: "50%",
                                        p: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <EmailIcon sx={{ color: "white" }} />
                                </Box>
                                <Link variant="body1" sx={{ fontWeight: "medium" }} color="#fff" href="mailto:info@ibraqservices.co.uk">
                                    info@ibraqservices.co.uk
                                </Link>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box
                                    sx={{
                                        backgroundColor: "#39b54a", // Green circle
                                        borderRadius: "50%",
                                        p: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Map sx={{ color: "white" }} />
                                </Box>
                                <Link variant="body1" sx={{ fontWeight: "medium", textAlign: "left" }} color="#fff" href="https://maps.app.goo.gl/LJSodoEqKvPAeA4U8">
                                    OF-5, Unit 1, Nimbus Park, Porz Avenue, Dunstable, Bedfordshire,LU5 5WZ
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default WhyTrustUsSection;